/*
 *
 * Package: `@dbh/generic-ui-constants`.
 *
 */const INPUT_FIELD_HEIGHT="44px";

export { INPUT_FIELD_HEIGHT };
